module.exports = __webpack_public_path__ + "img/Training_courses_icon_2.1990c875.svg";